// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Gzn3","option":"styles_option__1RZce","active":"styles_active__37D3f"};